/* @flow */

import fetchUrl, { fetchJson, postJson, putJson } from 'utils/fetch';

export const fetch = () => fetchJson('/bucket/folders.json');

export const save = (name: string) =>
  postJson('/bucket/folders.json', {
    name,
  });

export const update = (folder: BucketFolder) =>
  putJson(`/bucket/folders.json/${folder.id}`, folder);

export const remove = (folderId: number) =>
  fetchUrl(`/bucket/folders.json/${folderId}`, {
    method: 'DELETE',
  });



// WEBPACK FOOTER //
// ./src/modules/bucket/api/folders.js